const COMPANY_NAME = {
    HTZ: 'HitechZone',
    LS: 'LetStay',
    ELAL: 'Elal',
    ISRACARD: 'Isracard',
    AIRHAIFA:"AirHaifa",
};

module.exports = {
    COMPANY_NAME,
};
